import { useMutation } from "@tanstack/react-query";
import moment from "moment";
import React, { useState } from "react";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useAppDispatch, useAppSelector } from "@/hooks/application/store";
import { Client, ClientTypeEnum } from "@/interfaces/domain/Client";
import { UpdateClientParams, updateClientRequest } from "@/services/api/client";
import { UPDATE_CLIENT } from "@/store/ducks/auth";

import ProfileMobile from "./Profile.mobile";
import ProfileWeb from "./Profile.web";
import CompanyProfileEditModal from "./components/CompanyProfileEditModal";
import CustomerProfileEditModal from "./components/CustomerProfileEditModal";
import { CompanyFormData, CustomerFormData, FormData } from "./schema";

const Profile = () => {
  const { isWebMode } = useViewport();
  const { goBack } = useAppNavigation();
  const dispatch = useAppDispatch();

  const { user } = useAppSelector((store) => store.auth);
  const client = user?.cliente;
  const isCompany = user?.cliente?.tipo === ClientTypeEnum.B2B;

  const currentData = {
    nome: client.nome,
    data_nascimento: client.data_nascimento && moment(client.data_nascimento).format("DD/MM/YYYY"),
    razao_social: client.razao_social,
    telefone: client.telefone,
  } as FormData;

  const { mutate, isLoading } = useMutation<Client, unknown, Partial<UpdateClientParams>>({
    mutationFn: (data) => updateClientRequest(client._id, data),
    onSuccess: (data) => {
      dispatch(UPDATE_CLIENT(data));
      setModalVisible(false);
    },
  });

  const [modalVisible, setModalVisible] = useState(false);

  const onSubmit = (data: FormData) => {
    if (data.data_nascimento) {
      const [day, month, year] = data.data_nascimento.split("/");
      data.data_nascimento = new Date(Number(year), Number(month) - 1, Number(day)).toISOString();
    }
    mutate(data);
  };

  const Screen = isWebMode ? ProfileWeb : ProfileMobile;
  const renderModal = () =>
    isCompany ? (
      <CompanyProfileEditModal
        isOpen={modalVisible}
        isSubmiting={isLoading}
        currentData={currentData as CompanyFormData}
        onClose={() => setModalVisible(false)}
        onSubmit={onSubmit}
      />
    ) : (
      <CustomerProfileEditModal
        isOpen={modalVisible}
        isSubmiting={isLoading}
        currentData={currentData as CustomerFormData}
        onClose={() => setModalVisible(false)}
        onSubmit={onSubmit}
      />
    );

  return (
    <>
      <Screen
        user={user}
        client={client}
        onCancel={goBack}
        onPressEdit={() => setModalVisible(true)}
      />
      {renderModal()}
    </>
  );
};

export default Profile;
